<script>
  import { Link } from "svelte-routing";
  import { token } from "../stores.js";
</script>

<div class="not-found">
  <div class="logo" />
  <p>404</p>
  <div class="info-text">Stránka nebola nájdená</div>
  <div class="back-to">
    <p>prejsť späť na:</p>
    <p class="link"><Link to="/">Prehliadka</Link></p>
    <p class="link"><Link to="/login">Login</Link></p>
  </div>
  <div class="plug">
    <div class="male" />
    <div class="female" />
  </div>
</div>

<style lang="scss">
  @import "../assets/scss/themes.scss";

  .not-found {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60%;
    height: 60%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .logo {
      width: 160px;
      min-height: 40px;
      background-color: $text-color;
      mask-image: url("../assets/images/woow-logo-white.svg");
      mask-repeat: no-repeat;
      mask-size: contain;
    }
    p {
      font-size: 160px;
      color: $primary-color;
      font-weight: 400;
    }
    .info-text {
      text-align: center;
      color: $text-color;
      width: 336px;
      text-transform: uppercase;
      outline: 3px solid $text-color;
      padding: 15px 45px;
      font-size: 18px;
      z-index: 20;
    }
    .back-to {
      width: 180px;
      text-transform: uppercase;
      margin-top: 30px;
      text-align: center;
      color: $text-color;
      position: relative;
      top: 14px;
      z-index: 30;
      p {
        color: $text-color;
        font-size: 16px;
      }
      .link {
        display: inline-block;
        margin: 0 5px;
      }
    }

    .plug {
      width: 440px;
      min-height: 150px;
      outline: 3px solid $text-color;
      position: relative;
      border-radius: 16px;
      top: -83px;
      z-index: 3;
      &::before {
        content: "";
        position: relative;
        width: 340px;
        height: 5px;
        background-color: rgb(241, 245, 249);
        z-index: 10;
        display: block;
        left: 50%;
        transform: translateX(-50%);
        top: -4px;
      }
      &::after {
        position: relative;
        display: block;
        content: "";
        width: 200px;
        height: 5px;
        background-color: rgb(241, 245, 249);
        z-index: 10;
        bottom: -144px;
        left: 50%;
        transform: translateX(-50%);
      }
      .female {
        width: 30px;
        height: 30px;
        background-color: $text-color;
        position: absolute;
        border-radius: 4px;
        top: 136px;
        left: 119px;
        z-index: 15;
        &::after {
          display: block;
          position: relative;
          content: "";
          width: 11px;
          height: 41px;
          background-color: $text-color;
          left: 26px;
          top: -45px;
          border-radius: 5px;
        }
        &::before {
          content: "";
          display: block;
          position: relative;
          width: 100px;
          height: 40px;
          background-color: $primary-color;
          mask-image: url("../assets/images/woow-logo-white.svg");
          mask-repeat: no-repeat;
          mask-size: contain;
          mask-position: center;
          left: 50px;
          top: -4px;
        }
      }
      .male {
        width: 30px;
        height: 30px;
        background-color: $text-color;
        position: absolute;
        border-radius: 4px;
        top: 136px;
        right: 107px;
        z-index: 15;
        &::after {
          display: block;
          position: relative;
          content: "";
          width: 11px;
          height: 41px;
          background-color: $text-color;
          left: -6px;
          top: -10px;
          border-radius: 5px;
        }
        &::before {
          display: block;
          position: relative;
          content: "";
          width: 36px;
          height: 5px;
          background-color: $text-color;
          left: -24px;
          top: 7px;
          border-radius: 10px;
          box-shadow: 0px 13px $text-color;
        }
      }
    }
  }

  @media (max-width: 600px) {
    .not-found {
      .logo {
        width: 80px;
        height: 17px;
      }
      p {
        font-size: 80px;
      }
      .info-text {
        width: 175px;
      }
      .plug {
        width: 280px;
        &::before {
          width: 180px;
        }
        .male {
          right: 27px;
        }
        .female {
          left: 39px;
        }
      }
    }
  }
</style>
